import { DEFAULT_TOTAL_RECORDS } from "utils/constants";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");
const zone_id = Number(localStorage.getItem("zone_id"));

export const fetchArea = (page_no, filter, limit = DEFAULT_TOTAL_RECORDS) => {
    return axiosInstance.get(EndPoints.Area.LIST, {
        params: {
            limit,
            page_no,
            zone_id,
            ...filter
        }
    });
}

export const createArea = (payload) => {
    return axiosInstance.post(EndPoints.Area.CREATE, payload)
}

export const updateArea = (payload) => {
    return axiosInstance.put(EndPoints.Area.UPDATE, payload)
}


export const deleteArea = (payload) => {
    const url = EndPoints.Area.DELETE + `/${payload}`
    return axiosInstance.delete(url)
}

export const downloadAreaCSV = () => {
    return axiosInstance.put(EndPoints.Area.DOWNLOAD_CSV, {
        responseType: 'blob'
    });
}